export const LOADER_SET = 'loader/SET' as const;
export const SESSION_SET = 'session/SET' as const;

export interface LoaderSetAction {
  type: typeof LOADER_SET;
  data: boolean;
}

export interface SessionSetAction {
  type: typeof SESSION_SET;
  data: string;
}

export const loaderSet = (data: boolean): LoaderSetAction => ({
  type: LOADER_SET,
  data
});

export const sessionSet = (data: string): SessionSetAction => ({
  type: SESSION_SET,
  data
});
